import React, { useState, useMemo } from 'react'
import { HeaderContainer, Inner, LogoLink, LogoIcon, MenuToggle, DeskMenu, MenuLink, MenuIcon, MenuLine, SocialLink, SocialIcon, MobileMenu, MobileLink, MobileList, MobileSocial, MobileSocialLink, MobileActions, MobileHeaderButton } from './headerStyles'
import { DonateButton } from '../globalStyles';

const Header = ({links, headerButton}) => {
    const [active, setActive] = useState(false);
    const hasHeaderButton = !!(headerButton?.title && headerButton?.link);

    return useMemo(() => (
        <HeaderContainer role={`navigation`} aria-label={`main-navigation`}>
            <Inner>
                <LogoLink to="/" title={`Wangaratta Jazz & Blues`} target={`_self`} onClick={() => setActive(false)}>
                    <LogoIcon
                        name={'logoSmall'}
                    />
                </LogoLink>
                {links?.length ? (
                    <MobileActions>
                        {hasHeaderButton ? (
                            <MobileHeaderButton
                                href={headerButton.link}
                                target={headerButton?.external ? '_blank' : '_self'}
                                rel={headerButton?.external ? 'noopener noreferrer' : undefined}
                            >
                                {headerButton.title}
                            </MobileHeaderButton>
                        ) : null}
                        <MenuToggle aria-label={`Menu`} onClick={() => setActive(!active)}>
                            <MenuIcon
                                active={active}
                                name={active ? `cross` : `menu`}
                            />
                        </MenuToggle>
                    </MobileActions>
                ) : null}
                {links?.length ? (
                    <DeskMenu>
                        {links?.map((link, i) => {
                            return link.title.toLowerCase() === 'donate' ? (
                                <DonateButton
                                    key={link.title}
                                    href={link.url}
                                    target={link?.external ? '_blank' : '_self'}
                                >
                                    {link.title}
                                </DonateButton>
                            ) : (
                                <MenuLink 
                                    key={link.title} 
                                    to={link.url} 
                                    title={link.title} 
                                    target={link?.external ? '_blank' : '_self'}
                                    index={i}
                                    style={{ transition: `all ${0.5 + (0.1 * (i + 1))}s ease`}}
                                    onClick={() => setActive(false)}
                                >
                                    {link.title}
                                </MenuLink>
                            )
                        })}
                    </DeskMenu>
                ) : null}
                {links?.length ? (
                    <MobileMenu active={active}>
                        <MobileList>
                            {links?.map((link, i) => (
                                <MobileLink 
                                    key={link.title} 
                                    to={link.url} 
                                    title={link.title} 
                                    target={link?.external ? '_blank' : '_self'}
                                    index={i}
                                    onClick={() => setActive(false)}
                                >
                                    {link.title}
                                </MobileLink>
                            ))}
                        </MobileList>
                        <MobileSocial>
                            <MobileSocialLink href={`https://www.facebook.com/WangarattaJazzFestival/`} title={`Facebook`} target={`_blank`}>
                                <SocialIcon name={`facebookCircle`} />
                            </MobileSocialLink>
                            <MobileSocialLink href={`https://www.instagram.com/wangarattajazzandblues/`} title={`Instagram`} target={`_blank`}>
                                <SocialIcon name={`instagramCircle`} />
                            </MobileSocialLink>
                            <MobileSocialLink href={`https://www.youtube.com/@wangjazzblues`} title={`Youtube`} target={`_blank`}>
                                <SocialIcon name={`youtubeCircle`} />
                            </MobileSocialLink>
                            <MobileSocialLink href={`https://www.tiktok.com/@wangjazzblues`} title={`TikTok`} target={`_blank`}>
                                <SocialIcon name={`tiktokCircle`} />
                            </MobileSocialLink>
                        </MobileSocial>
                    </MobileMenu>
                ) : null}
            </Inner>
        </HeaderContainer>
    ), [active, links, hasHeaderButton, headerButton]);
}

export default Header
